<template>
  <div>
    <el-button
      class="filter-item over-element-btn"
      type="primary"
      size="mini"
      @click="openDialog"
      >隐藏表列</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      title="选择需要隐藏的数据"
      :close-on-click-modal="false"
      width="680px"
      class="custom-dialog-center"
    >
      <el-form
        ref="formEdit"
        :model="formEdit"
        label-position="right"
        label-width="160px"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="checkedColumons"
          @change="handlecheckedColumonsChange"
        >
          <el-checkbox
            v-for="item in columons"
            :label="item.prop"
            :key="item.prop"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="mini"
          class="over-element-btn"
          type="primary"
          @click="createConfirm('formEdit')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { fetchUpdate, fetchSelected } from "@/api/changeColumon";
// fetchList,
import allItems from "./items";
export default {
  props: {
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      columonArr: [],
      dialogVisible: false,
      formEdit: {},
      checkAll: false,
      checkedColumons: [],
      columons: [],
      isIndeterminate: false,
    };
  },
  created() {
    this.getColumon();
  },
  methods: {
    getColumon() {
      // console.log(allItems[this.url])
      // fetchList({ requestUri: this.url }).then(response => {
      //   if (response.columnDictionary) {
      //     this.columons = JSON.parse(response.columnDictionary)
      this.columons = allItems[this.url];
      fetchSelected({ permissionCode: this.url }).then((resSelect) => {
        var selected = resSelect.nonFilterColumn || "[]";
        this.checkedColumons = JSON.parse(selected);
        if (
          this.checkedColumons.length > 0 &&
          this.checkedColumons.length < this.columons.length
        ) {
          this.isIndeterminate = true;
        }
        this.$emit("get-column-data", this.checkedColumons);
      });
      //   }
      // })
    },
    openDialog() {
      this.dialogVisible = true;
    },
    createConfirm() {
      fetchUpdate({
        permissionCode: this.url,
        nonFilterColumn: this.checkedColumons,
      }).then((response) => {
        this.dialogVisible = false;
        this.$message.success("修改成功");
        this.$emit("get-column-data", this.checkedColumons);
      });
    },
    handleCheckAllChange(val) {
      this.checkedColumons = val ? this.columons.map((item) => item.prop) : [];
      this.isIndeterminate = false;
    },
    handlecheckedColumonsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columons.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.columons.length;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/TableHide/index.vue